import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [sucursal, setSucursalState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    const savedSucursal = localStorage.getItem('sucursal');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
    if (savedSucursal) {
      setSucursalState(JSON.parse(savedSucursal));
    }
    setLoading(false);
  }, []);

  const login = async (email, password, id_empresa) => {
    // Legacy: login en un paso. Se mantiene para compatibilidad.
    const response = await authService.login({ email, password, id_empresa });
    const data = response.data;
    localStorage.setItem('token', data.access_token);
    localStorage.setItem('user', JSON.stringify(data));
    setUser(data);
    return data;
  };

  const finalizarSesion = (tokenData) => {
    // Nuevo flujo: recibe el response del endpoint /auth/finalizar y lo persiste como sesión activa.
    localStorage.setItem('token', tokenData.access_token);
    localStorage.setItem('user', JSON.stringify(tokenData));
    setUser(tokenData);
  };

  const setSucursal = (suc) => {
    localStorage.setItem('sucursal', JSON.stringify(suc));
    setSucursalState(suc);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('sucursal');
    setUser(null);
    setSucursalState(null);
  };

  return (
    <AuthContext.Provider value={{ user, sucursal, setSucursal, login, finalizarSesion, logout, loading, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth debe usarse dentro de AuthProvider');
  return context;
};
